import React from 'react';
import PropTypes from 'prop-types';
import Tab from './Tab';

class TabGroup extends React.Component{
    
        render() {
            const tabs = this.props.tabs.map(tab => {
                return (
                    <li key={tab}>
                        <Tab tabName={tab} currentTab={this.props.currentTab === tab} onClick={this.props.onChange}/>
                    </li>
                );
            });

            return (
                <ul className="tab-bar">
                    {tabs}
                </ul>
            );
        }
    }
    
    TabGroup.propTypes = {
        tabs: PropTypes.array.isRequired,
        currentTab: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired
    }
    
    export default TabGroup;


/** WEBPACK FOOTER **
 ** ./src/components/ui/TabGroup.js
 **/